export const successMessages = {
    EmployeeActivated: 'Medewerker geactiveerd',
    EmployeeDeactivated: 'Medewerker gedeactiveerd',
    BranchCreated: 'Vestiging aangemaakt',
    CompanyCreated: 'Bedrijf aangemaakt',
    OrganizationUpdated: 'Bedrijf bijgewerkt',
    OrganizationDeleted: 'Bedrijf verwijderd',
    EmployeeMoved: 'Medewerker verplaatst',
    SourceDeleted: 'Bron verwijderd',
    TeamCreated: 'Team aangemaakt',
    TeamUpdated: 'Team bijgewerkt',
    EmployeeRemovedFromTeam: 'Medewerker uit team verwijderd',
    TeamDeleted: 'Team verwijderd',
    Reconnected: 'Verbinding met de server is hersteld',
    FileDownloaded: 'Bestand gedownload',
    PasswordSet: 'Wachtwoord is ingesteld',
    EmailUpdated: 'E-mailadres gewijzigd',
    PasswordUpdated: 'Wachtwoord gewijzigd',
    EmployeesLinked: 'Medewerker(s) gekoppeld',
    OriginalValuesRestored: 'Originele waarden teruggezet',
    SwitchedOrganization: 'Succesvol gewisseld',
    ForgotPasswordSent:
        'Instructies voor het wijzigen van je wachtwoord zijn verzonden. Het kan enkele minuten duren voordat je een e-mail van ons ontvangt. Controleer ook je spamfolder als je twijfelt. Heb je geen bericht ontvangen? Probeer het dan opnieuw.',
    PasswordResetLinkSent: 'Wachtwoord reset link verzonden',
    FileDownloadSuccess: 'Bestand gedownload',
    ExtractFileContentSuccess: 'Bestandsinhoud succesvol geretourneerd',
    ActionPointCreated: 'Actiepunt aangemaakt',
    ActionPointUpdated: 'Actiepunt bijgewerkt',
    ActionPointsUpdated: 'Actiepunten bijgewerkt',
    NoteCreated: 'Notitie aangemaakt',
    SourceSaved: 'Bron opgeslagen',
    NotificationSent: 'Notificatie gestuurd',
    ActionPointDeleted: 'Actiepunt verwijderd',
    ActionPointsDeleted: 'Actiepunten verwijderd',
    ActionPointsImported: 'Actiepunten geïmporteerd',
    EmployeeCreated: 'Medewerker aangemaakt',
    EmployeeUpdated: 'Medewerker bijgewerkt',
    LoggedOut: 'Je bent uitgelogd',
    Welcome: 'Welkom {name}',
    TemplateCreated: 'Sjabloon aangemaakt'
};
